import { render } from "./CaseInformations.vue?vue&type=template&id=d1fb387e&scoped=true"
import script from "./CaseInformations.vue?vue&type=script&lang=js"
export * from "./CaseInformations.vue?vue&type=script&lang=js"

import "./CaseInformations.vue?vue&type=style&index=0&id=d1fb387e&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1fb387e"],['__file',"src/components/orders/CaseInformations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d1fb387e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d1fb387e', __exports__)) {
    console.log('reload')
    api.reload('d1fb387e', __exports__)
  }
  
  module.hot.accept("./CaseInformations.vue?vue&type=template&id=d1fb387e&scoped=true", () => {
    console.log('re-render')
    api.rerender('d1fb387e', render)
  })

}


export default __exports__